<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @del="del"
    >
      <Header
        slot="header"
        @addGoods="() => (orderGoodsDialogVisible = true)"
        @batchDel="batchDel"
        :disabled="disabled"
      />
    </Main>
    <choose-order-goods-dialog
      :visible.sync="orderGoodsDialogVisible"
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :orderCode="orderCode"
      @confirm="orderGoodsConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
import ChooseOrderGoodsDialog from '@/views/factory/components/choose-order-goods/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, ChooseOrderGoodsDialog },
  props: {
    orderInspectionCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false }, // 作为标识，判断用户操作是否执行API还是删除缓存中的数据，应为该组件在表格展开插槽中使用也在表格中使用
  },
  data() {
    return {
      loading: false,
      tableData: [],
      orderGoodsDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderInspectionCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .orderInspectionGoodsListApi({
          orderInspectionCode: this.orderInspectionCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    orderGoodsConfirm(data) {
      if (this.isExpand) {
        this.addDBData(data)
        return
      }
      this.addTableData(data)
    },
    addTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            orderGoodsDisplayName: i.orderGoodsDisplayName,
            orderGoodsNo: i.orderGoodsNo,
            identifyGoodsNo: i.identifyGoodsNo,
            orderGoodsCode: i.orderGoodsCode,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex((j) => j.orderGoodsNo === i.orderGoodsNo) <
            0
        )
      this.tableData.push(...tableData)
    },
    addDBData(data) {
      const listGoodsCode = data
        .map((i) => i.orderGoodsCode)
        .filter(
          (i) => this.tableData.findIndex((j) => j.orderGoodsCode === i) < 0
        )

      if (listGoodsCode.length !== data.length) {
        this.$message(
          this.$l('inspection_choose_goods_repeat_tips') ||
            '已为您过滤掉重复的产品信息！'
        )
      }

      if (!listGoodsCode || !listGoodsCode.length) return
      const params = {
        orderCode: this.orderCode,
        orderInspectionCode: this.orderInspectionCode,
        listGoodsCode,
      }
      this.loadingOpen()
      this.$api
        .orderInspectionGoodsSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    batchDel() {
      if (!this.tableData || !this.tableData.length) return
      const delRows = this.$refs.main.getCheckboxRecords()
      if (!delRows) return
      if (this.isExpand) {
        this.delDBData(delRows)
        return
      }
      this.delTableData(delRows)
    },
    delTableData(delRows) {
      const tableData = this.tableData.filter(
        (i) => delRows.findIndex((j) => i.orderGoodsNo == j.orderGoodsNo) < 0
      )
      this.tableData = [...tableData]
    },
    delDBData(delRows) {
      const listGoodsCode = delRows.map((i) => i.orderInspectionGoodsCode)
      const dataCount = this.tableData.length || 0

      let delTipsText = this.$l('INDEX.tips_delete') || '是否要删除该记录？'
      if (listGoodsCode.length >= dataCount)
        delTipsText =
          this.$l('table_del_goods_last_tips') ||
          '执行次操作会导致，该订单验货要求和验货文档也一并删除！是否确认继续删除？'

      this.$confirm(
        delTipsText,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .orderInspectionGoodsBatchDelApi({ listGoodsCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
            if (listGoodsCode.length >= dataCount) this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    del(orderGoodsCode) {
      const delRow = this.tableData.filter(
        (i) => i.orderGoodsCode === orderGoodsCode
      )
      if (this.isExpand) {
        this.delDBData(delRow)
        return
      }
      this.delTableData(delRow)
    },
    getGoodsCodes() {
      return this.tableData.map((i) => i.orderGoodsCode)
    },
  },
}
</script>
